<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:34:49
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\noTrip\notrip.vue
-->
<template>
  <div ref="Notrip" class="notrip">
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/no-trip11305.png"
      :alt="this.title"
    />
    <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "Notrip",
  props: {
    type: { type: String, default: null },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    subTitle: {
      type: String,
      default: "点击右上角“预订或补单”新增行程"
    },
    title: {
      type: String,
      default: null
    }
  }
};
</script>
<style lang="scss" scoped>
.notrip {
  text-align: center;
  .icon-img {
    height: 58px;
    width: 40px;
  }
}
</style>
